import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const keys = () =>
	createEnv({
		server: {
			DATABASE_URL: z
				.string()
				.url()
				.describe("PostgreSQL connection string (pooled, via PgBouncer:6432)"),
			DIRECT_DATABASE_URL: z
				.string()
				.url()
				.optional()
				.describe("Direct, non-pooled connection (port 5432) for migrations"),
		},
		client: {},
		runtimeEnv: {
			DATABASE_URL: process.env.DATABASE_URL,
			DIRECT_DATABASE_URL: process.env.DIRECT_DATABASE_URL,
		},
	});
